import {loadProductJson} from '@/product/product-selection/load-product-json';
import {h} from 'preact';
import register from 'preact-custom-element';
import SteppedProductSelector from './SteppedProductSelector';

function Loader({product}: SteppedProductSelectorLoaderProps) {
  // If feature flag present, apply a price mapping to the 'Add To Cart' handler
  // This should transform the price of each line item based on the price test

  loadProductJson(product);

  return h(SteppedProductSelector, {});
}

register(Loader, 'stepped-product-selector', ['product', 'settings']);

type SteppedProductSelectorLoaderProps = {
  product: string;
  settings: string;
};
